export const optionsSpecialty = [
  { value: '1', label: 'Administration' },
  { value: '2', label: 'Advanced Practice' },
  { value: '3', label: 'Allergy' },
  { value: '4', label: 'Ambulatory' },
  { value: '5', label: 'Anesthesia' },
  { value: '6', label: 'Blood Management' },
  { value: '7', label: 'Cardiac Care' },
  { value: '8', label: 'Cardiac Cath Lab' },
  { value: '9', label: 'Case Management' },
  { value: '10', label: 'Clinical Informatics' },
  { value: '11', label: 'Critical Care' },
  { value: '12', label: 'Dermatology' },
  { value: '13', label: 'Development Disability' },
  { value: '14', label: 'Diabetes' },
  { value: '15', label: 'Dialysis' },
  { value: '16', label: 'Education / Instruction' },
  { value: '17', label: 'Emergency' },
  { value: '18', label: 'ENT' },
  { value: '19', label: 'Fertility' },
  { value: '20', label: 'Gastroenterology' },
  { value: '21', label: 'Genetics' },
  { value: '22', label: 'Geriatrics' },
  { value: '23', label: 'Hematology' },
  { value: '24', label: 'HIV/AIDS' },
  { value: '25', label: 'Home Health' },
  { value: '26', label: 'Hospice' },
  { value: '27', label: 'Infection Control' },
  { value: '28', label: 'Infectious Disease' },
  { value: '29', label: 'Infusion' },
  { value: '30', label: 'Medical / Surgical' },
  { value: '31', label: 'Mother Baby' },
  { value: '32', label: 'Neonatal Critical Care' },
  { value: '33', label: 'Neurology' },
  { value: '34', label: 'Nursery' },
  { value: '35', label: 'Obstetric / Labor & Delivery' },
  { value: '36', label: 'Occupational Health' },
  { value: '37', label: 'Oncology' },
  { value: '38', label: 'Operating Room / Surgical' },
  { value: '39', label: 'Ophthalmology' },
  { value: '40', label: 'Orthopedics' },
  { value: '41', label: 'PACU / Surgical Recovery Room' },
  { value: '42', label: 'Pain Management' },
  { value: '43', label: 'Palliative Care' },
  { value: '44', label: 'PCU / Stepdown' },
  { value: '45', label: 'Pediatric Critical Care' },
  { value: '46', label: 'Pediatrics' },
  { value: '47', label: 'Plastic Surgery' },
  { value: '48', label: 'Primary Care' },
  { value: '49', label: 'Psychiatry' },
  { value: '50', label: 'Public Health' },
  { value: '51', label: 'Pulmonary Care' },
  { value: '52', label: 'Quality Assurance' },
  { value: '53', label: 'Radiology' },
  { value: '54', label: 'Rehabilitation' },
  { value: '55', label: 'Renal' },
  { value: '56', label: 'Reproductive' },
  { value: '57', label: 'Research' },
  { value: '58', label: 'Rheumatology' },
  { value: '59', label: 'Substance Abuse' },
  { value: '60', label: 'Telemetry' },
  { value: '61', label: 'Toxicology' },
  { value: '62', label: 'Transplant' },
  { value: '63', label: 'Transport' },
  { value: '64', label: 'Trauma' },
  { value: '65', label: 'Urology' },
  { value: '66', label: 'Vascular' },
  { value: '67', label: "Women's Health" },
  { value: '68', label: 'Wound' }
];
export const optionsCertification = [
  { value: '1', label: 'ACLS' },
  { value: '2', label: 'APHN-BC' },
  { value: '3', label: 'AWHONN' },
  { value: '4', label: 'BLS' },
  { value: '5', label: 'CCRN' },
  { value: '6', label: 'CEN' },
  { value: '7', label: 'CMSRN' },
  { value: '8', label: 'CNOR' },
  { value: '9', label: 'CPI' },
  { value: '10', label: 'CRRN' },
  { value: '11', label: 'OCN' },
  { value: '12', label: 'PALS' },
  { value: '13', label: 'NRP' },
  { value: '14', label: 'NIHSS' },
  { value: '15', label: 'RN-BC' },
  { value: '16', label: 'RNC' },
  { value: '17', label: 'STABLE' },
  { value: '18', label: 'TNCC' }
];
export const optionsExperienceLevel = [
  { value: '1', label: '0 - 1 year ' },
  { value: '2', label: '1 - 2 years' },
  { value: '3', label: '2+ years' }
];
export const optionsEMR = [
  { value: '1', label: 'ABELMed' },
  { value: '2', label: 'AdvancedMD' },
  { value: '3', label: 'AllegianceMD' },
  { value: '4', label: 'Amazing Charts' },
  { value: '5', label: 'AthenaHealth' },
  { value: '6', label: 'Axxess' },
  { value: '7', label: 'CampDoc' },
  { value: '8', label: 'Care360' },
  { value: '9', label: 'Centricity EMR' },
  { value: '10', label: 'Cerner' },
  { value: '11', label: 'Clinicient INSIGHT' },
  { value: '12', label: 'Dr. Cloud EHR' },
  { value: '13', label: 'EpicCare' },
  { value: '14', label: 'iClinic Systems' },
  { value: '15', label: 'InSync EMR' },
  { value: '16', label: 'InteGreat EHR' },
  { value: '17', label: 'Kareo Clinical' },
  { value: '18', label: 'MatrixCare' },
  { value: '19', label: 'MDVision PM EMR' },
  { value: '20', label: 'MicroMD' },
  { value: '21', label: 'Nextech EMR' },
  { value: '22', label: 'NextGen Healthcare' },
  { value: '23', label: 'Office Ally EHR 24/7' },
  { value: '24', label: 'OpenEMR' },
  { value: '25', label: 'Optum Physician' },
  { value: '26', label: 'PointClickCare' },
  { value: '27', label: 'Practice Fusion' },
  { value: '28', label: 'Praxis' },
  { value: '29', label: 'PrognoCIS' },
  { value: '30', label: 'ReLi Med Solutions' },
  { value: '31', label: 'TherapyNotes' },
  { value: '32', label: 'TouchWorks EHR' },
  { value: '33', label: 'Yardi' }
];
export const timeOffTypes = [
  { value: '1', label: 'Full Day' },
  { value: '2', label: 'Partial Day' }
];
export const templateTypes = [
  { value: '1', label: 'Global' },
  { value: '2', label: 'Private' }
];
export const jobDropDownStatus = [
  { value: '0', label: 'All' },
  { value: '1', label: 'Open' },
  { value: '2', label: 'Nurse Assigned' },
  { value: '3', label: 'In-Progress' },
  { value: '4', label: 'Completed' },
  { value: '5', label: 'Unfulfilled' },
  { value: '6', label: 'Missed' },
  { value: '7', label: 'Pending Clock Out' }
];
export const jobTypes = [
  { value: '1', label: 'Shift' },
  { value: '2', label: 'Visit' }
];
export const licenseTypes = [
  { value: '1', label: 'LPN' },
  { value: '2', label: 'CNA' },
  { value: '3', label: 'RN' },
  { value: '4', label: 'HHA' }
];
export const duration = [
  { label: '1 Hour', value: 1 },
  { label: '2 Hours', value: 2 },
  { label: '3 Hours', value: 3 },
  { label: '4 Hours', value: 4 },
  { label: '5 Hours', value: 5 },
  { label: '6 Hours', value: 6 },
  { label: '7 Hours', value: 7 },
  { label: '8 Hours', value: 8 },
  { label: '9 Hours', value: 9 },
  { label: '10 Hours', value: 10 },
  { label: '11 Hours', value: 11 },
  { label: '12 Hours', value: 12 }
];
export const weeks = [
  { label: '1 Week', value: 1 },
  { label: '2 Weeks', value: 2 },
  { label: '3 Weeks', value: 3 },
  { label: '4 Weeks', value: 4 },
  { label: '5 Weeks', value: 5 },
  { label: '6 Weeks', value: 6 },
  { label: '7 Weeks', value: 7 },
  { label: '8 Weeks', value: 8 }
];

export const slots = [
  { label: '1 Slot', value: 1 },
  { label: '2 Slots', value: 2 },
  { label: '3 Slots', value: 3 },
  { label: '4 Slots', value: 4 },
  { label: '5 Slots', value: 5 },
  { label: '6 Slots', value: 6 },
  { label: '7 Slots', value: 7 },
  { label: '8 Slots', value: 8 }
];

export const optionsDoc = [
  { label: 'Background & ID', value: 1 },
  { label: 'License', value: 2 },
  { label: 'Certification', value: 3 },
  { label: 'Health Document', value: 4 },
  { label: 'Assessment', value: 5 },
  { label: 'Misc Documents', value: 6 }
];

export const optionsSkill = [
  { value: '1', label: 'Teamwork' },
  { value: '2', label: 'Time management' },
  { value: '3', label: 'Effective communication' },
  { value: '4', label: 'Compassion' }
];
